import { IconWrapper } from '../runtime';
export default IconWrapper('unordered-list', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.73438 7.99951H14.25M5.73438 13.7495H14.25M5.73438 2.24951H14.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 3.49975C2.94036 3.49975 3.5 2.9401 3.5 2.24975C3.5 1.5594 2.94036 0.999756 2.25 0.999756C1.55965 0.999756 1 1.5594 1 2.24975C1 2.9401 1.55965 3.49975 2.25 3.49975Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.5 7.99975C3.5 8.6901 2.94036 9.24975 2.25 9.24975C1.55965 9.24975 1 8.6901 1 7.99975C1 7.3094 1.55965 6.74976 2.25 6.74976C2.94036 6.74976 3.5 7.3094 3.5 7.99975Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 14.9997C2.94036 14.9997 3.5 14.4401 3.5 13.7498C3.5 13.0594 2.94036 12.4998 2.25 12.4998C1.55965 12.4998 1 13.0594 1 13.7498C1 14.4401 1.55965 14.9997 2.25 14.9997Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});